import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
interface SecondaryBreadcrumbsItemProps extends Partial<Omit<HTMLElement, 'children'>> {
  children: React.ReactNode
  isLast: boolean
}

export default function SecondaryBreadcrumbsItem({
  children,
  isLast,
  className,
}: SecondaryBreadcrumbsItemProps): ReactNode {
  return <h2 className={twMerge(isLast && 'text-text-primary', className)}>{children}</h2>
}
